import * as t from 'io-ts';

import {enforceType} from '../../../libs/shared/helpers/src/typescript/typeHelpers';
import {ApplicationResourceIdBrand} from '../../applications/bridge/v2/types/bridgeTypesV2';

const publicUidRegexp = /^[a-z]{3}:([0-9a-f]{32})$/;

/*
 * Runtime type.
 */

type PublicUidBrandNames = {
  draft: 'publicUidDraft';
};

const publicUidBrandNames: PublicUidBrandNames = {
  draft: 'publicUidDraft',
};

const publicUidPrefixes: {[K in keyof PublicUidBrandNames]: string} = {
  draft: 'dra',
};

export function makePublicUidType<T extends keyof PublicUidBrandNames>(resourceType: T) {
  return t.brand(
    t.string,
    (id): id is t.Branded<string, Pick<ApplicationResourceIdBrand, PublicUidBrandNames[T]>> =>
      publicUidRegexp.test(id) && id.startsWith(publicUidPrefixes[resourceType]),
    publicUidBrandNames[resourceType],
  );
}

/*
 * Type.
 */

export type PublicUid<T extends keyof PublicUidBrandNames> = t.Branded<
  string,
  Pick<ApplicationResourceIdBrand, PublicUidBrandNames[T]>
>;

/*
 * Helpers.
 */

export function buildPublicUid<T extends keyof PublicUidBrandNames>(resourceType: T, uid: string) {
  const publicId = `${publicUidPrefixes[resourceType]}:${uid}`;
  return enforceType(makePublicUidType(resourceType), publicId);
}

export function tryParsePublicUid(publicId: string): string | undefined {
  const matches = publicId.match(publicUidRegexp);
  if (!matches) {
    return undefined;
  }

  return matches[1];
}
